import {Component} from '@angular/core';

@Component({
  selector: 'app-step-four-left-panel',
  templateUrl: './step-four-left-panel.component.html',
  styleUrls: ['./step-four-left-panel.component.css']
})
export class StepFourLeftPanelComponent {

}
